import { loadToken } from "@/hooks/useLocalStorage"
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios"

// Create a base API client
const createApiClient = (config?: AxiosRequestConfig): AxiosInstance => {
  return axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
      "Content-Type": "application/json",
    },
    ...config,
  })
}

// Create an authenticated API client
export const authenticatedApi = createApiClient({})

authenticatedApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      const currentPathName = window.location.pathname

      // Cannot use router because it's not a client component.
      // Cannot use redirect because it's not a server component.
      window.location.href = `/login?next=${currentPathName}`
    }
    return Promise.reject(error)
  },
)

export const setToken = (token: string) => {
  authenticatedApi.defaults.headers["Authorization"] = `Token ${token}`
}

export const removeApiToken = () => {
  delete authenticatedApi.defaults.headers["Authorization"]
}

const _token = loadToken()
if (_token !== null) {
  setToken(_token)
}

// Create a non-authenticated API client
export const api = createApiClient()

// Helper function to handle API responses
export const handleApiResponse = <T>(response: AxiosResponse<T>): T => {
  return response.data
}

// Helper function to handle API errors
export const handleApiError = (error: unknown, resourceName: string): never => {
  console.error(`Error with ${resourceName}:`, error)
  throw error
}
